import { useEffect, useState } from 'react';
import { PublicBanner, useGetPublicAdvBannerQuery } from '../../../services/content_v1';
import { useMediaQuery } from './TemporalBanner';


interface WelcomeAdBannerProps {
    label: 'advertising-banners-1' | 'advertising-banners-2',
}

function WelcomeAdBanner({ label }: WelcomeAdBannerProps) {
    const isMobile = useMediaQuery('(max-width: 760px)');

    const { data } = useGetPublicAdvBannerQuery(label);

    const [banner, setBanner] = useState<PublicBanner | undefined>();
    const [img, setImg] = useState<string>();
    const [img2, setImg2] = useState<string>();
    const [link, setLink] = useState<string>('');

    useEffect(() => {
        if (data?.results?.id) {
            setBanner(data.results);
            setImg(data.results.img_size1);
            setImg2(data.results.img_size2 || data.results.img_size1);
            const tmp = data.results.link_url;
            const utm = data.results.utm;
            if (utm) {
                if (tmp.includes('?')) {
                    setLink(tmp + '$utm=' + utm);
                } else {
                    setLink(tmp + '?utm=' + utm);
                }
            } else {
                setLink(tmp);
            }
        } else {
            setBanner(undefined);
            setImg('')
            setImg2('')
            setLink('')
        }
    }, [data]);

    return banner ? (
        <section className="welcome-promo-container _wide _mid-section">
            <a href={link} target="_blank">
                <img src={isMobile ? img2 : img} loading="lazy" alt="" className="welcome-live__ad-placeholder" style={{ borderRadius: '14px' }} />
            </a>
        </section>
    ) : null;
}

export default WelcomeAdBanner;